/**
 * @module accountsAsset
 * @description A list of accountsAsset
 */
export const accountsAsset = [
	{
		objectNumber: 54007,
		name: 'Software',
	},
	{
		objectNumber: 54003,
		name: 'Inventory',
	},
	{
		objectNumber: 54006,
		name: 'Buildings',
	},
	{
		objectNumber: 54009,
		name: 'Motor Vehicles',
	},
	{
		objectNumber: 54005,
		name: 'Office Equipment',
	},
	{
		objectNumber: 54008,
		name: 'Office Supplies',
	},
	{
		objectNumber: 54001,
		name: 'Cash on Hand',
	},
	{
		objectNumber: 54004,
		name: 'Land',
	},
	{
		objectNumber: 54002,
		name: 'Fixed',
	},
]
